import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
  name: "fyberErrorMessage",
})
export class FyberErrorPipe implements PipeTransform {
  transform(message: any, args?: any): any {
    let result: any;
    try {
      result = JSON.parse(message);
    } catch (e) {
      return message;
    }
    return `${result?.message || message}`;
  }
}
